import type { ReactNode } from "react";

type FilterFieldProps = {
  label: string;
  children: ReactNode;
};

/** A labelled filter control (label above the input), for filter bars. */
export default function FilterField({ label, children }: FilterFieldProps) {
  return (
    <div className="flex flex-col">
      <label className="mb-1 text-xs font-medium text-gray-500">{label}</label>
      {children}
    </div>
  );
}
